import React, { useEffect, useState } from "react";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteOnboardingProcessAssignmentAction,
  getOnboardingProcessAssignmentAction,
} from "../actions";
import {
  getData,
  getLoading,
  getCollaboratorsList,
  getCanAssign,
} from "../selectors";
import { RESET_STATE } from "../actionTypes";
import { openDialogAction } from "@icarius-common/dialog/actions";
import { getLocalizedString } from "@icarius-localization/strings";

const useOnboardingProcessesAssignment = (processCode) => {

  const [createDialogIsOpen, setCreateDialogIsOpen] = useState(false);

  const dispatch = useDispatch();
  const isLoading = useSelector(getLoading);
  const data = useSelector(getData);
  const colaboratorsList = useSelector(getCollaboratorsList);
  const canAssign = useSelector(getCanAssign);

  useEffect(() => {
    if (Boolean(processCode)) {
      dispatch(getOnboardingProcessAssignmentAction(processCode));
    }
    return () => dispatch({ type: RESET_STATE });
  }, [dispatch, processCode])

  const showClosedStatusWarning = () => {
    dispatch(openSnackbarAction({
      msg: getLocalizedString("toCreateCollaboratorsOrDeleteThemProcessMustBeOpen"),
      severity: "info",
      duration: 10000,
    }));
  }

  const handleOpenCreateDialog = (processStatus) => {
    if (processStatus === "C") {
      showClosedStatusWarning();
      return;
    }

    if (!canAssign) {
      dispatch(openDialogAction({
        title: getLocalizedString("atention"),
        msg: (
          <>
            {getLocalizedString("onBoardingProcessAssignmentMessage2Linea1")}
            <br />
            {getLocalizedString("onBoardingProcessAssignmentMessage2Linea2")}
          </>
        ),
        acceptOnly: true,
      }));
      return;
    }

    setCreateDialogIsOpen(true);
  }

  const handleOpenDeleteDialog = (processStatus, gridRef) => {
    if (processStatus === "C") {
      showClosedStatusWarning();
      return;
    }

    let selectedRows = gridRef.api.getSelectedRows();
    if (selectedRows.length === 0) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectAtLeastOneRecord"), severity: "warning" }));
      return;
    }

    const collaborators = selectedRows.map((item) => item['CODIGO DE EMPLEADO']);

    dispatch(openDialogAction({
      maxWidth: "md",
      title: getLocalizedString("atention"),
      msg: (
        <>
          {getLocalizedString("onBoardingProcessAssignmentMessage1Linea1")}
          <br />
          {getLocalizedString("onBoardingProcessAssignmentMessage1Linea2")}
          <br />
          {getLocalizedString("onBoardingProcessAssignmentMessage1Linea3")}
          <br />
          {getLocalizedString("onBoardingProcessAssignmentMessage1Linea4")}
          <br />
          <br />
          {getLocalizedString("onBoardingProcessAssignmentMessage1Linea5")}
        </>
      ),
      onConfirm: () => {
        dispatch(openDialogAction({
          maxWidth: "md",
          title: getLocalizedString("atention"),
          msg: getLocalizedString("areYouSureYouWantToDeleteCollaboratorOnboardingProcess"),
          onConfirm: () => dispatch(deleteOnboardingProcessAssignmentAction({ processCode, collaborators })),
        }));
      }
    }));
  }

  const handleCloseCreateDialog = () => {
    setCreateDialogIsOpen(false);
  }

  const state = {
    createDialogIsOpen,
  }

  const handlers = {
    handleOpenDeleteDialog,
    handleOpenCreateDialog,
    handleCloseCreateDialog,
  }

  return {
    isLoading,
    data,
    colaboratorsList,
    state,
    handlers,
  }
}

export default useOnboardingProcessesAssignment;